<template>
  <b-container v-if="this.type">
    <h1 v-translate>New Item Packs</h1>
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <translate>The Item Packs has been created</translate>
      </b-alert>
      <b-form @submit.prevent="postItem">
        <b-form-row>
          <b-col sm="4" lg="3">
            <label for="reference" class="col-form-label" v-translate>Pack Reference <small class="text-danger">*</small></label>
          </b-col>
          <b-col>
            <b-form-input id="reference" type="text" v-model="item.reference" required />
            <small tabindex="-1" class="form-text text-muted" v-translate>Reference to describe the content of the pack</small>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="4" lg="3">
            <label for="pack-size" class="col-form-label" v-translate>Items Quantity <small class="text-danger">*</small></label>
          </b-col>
          <b-col>
            <b-form-input id="pack-size" type="number" v-model="item.quantity" required />
            <small tabindex="-1" class="form-text text-muted" v-translate>Quantity of items in the pack</small>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="4" lg="3">
            <label for="quantity" class="col-form-label" v-translate>Quantity of Packs <small class="text-danger">*</small></label>
          </b-col>
          <b-col>
            <b-form-input id="quantity" type="number" v-model="item.packs_quantity" required />
            <small tabindex="-1" class="form-text text-muted" v-translate>How many packs should be created with the same Reference and Quantity?</small>
          </b-col>
        </b-form-row>
        <b-form-row v-if="isInternational">
          <b-col sm="4" lg="3">
            <label for="country_iso_code" class="col-form-label" v-translate>Country Iso Code</label>
          </b-col>
          <b-col>
            <b-form-input id="country_iso_code" type="text" v-model="item.country_iso_code" />
            <small tabindex="-1" class="form-text text-muted" v-translate>Country ISO 3166-1 alpha 2 code (ie. AR or BR)</small>
          </b-col>
        </b-form-row>
        <b-button type="submit" variant="primary" v-translate>Submit</b-button>
      </b-form>
  </b-container>
</template>
<script>
export default {
  name: 'ApiItemNew',
  props: {
    type: {
      type: String,
      default: 'item-packs'
    }
  },
  data () {
    return {
      fields: this.$appConfig.models[this.type].fields.filter(el => el.key !== 'actions'),
      item: {
        packs_quantity: 1
      },
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  watch: {
    type: function (val) {
      this.fields = this.$appConfig.models[this.type].fields
    }
  },
  mounted() {
    // this.getItem()
  },
  methods: {
    getItem() {
      this.$http.get(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id)
        .then(response => {
          this.item = response.body
        })
    },
    postItem() {
      for (let field in this.fields) {
        if (this.fields[field].toLowerCase) {
          this.item[this.fields[field].key] = this.item[this.fields[field].key].toLowerCase()
        }
      }
      this.$http.post(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint, this.item)
        .then(response => {
          this.showAlert()
          this.item = response.body

          this.$router.push('/list/' + this.$appConfig.models[this.type].endpoint, { query: { created: true } })
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    snakeCaseToTitleCase(str) {
      return str.replace(/_/g, ' ').replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    }
  }
}
</script>
